// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0a9a0aa3","160":"0a74d0ff","208":"cbead4e7","293":"7c74c44a","453":"226cfe9b","516":"14c524c1","519":"bf038708","917":"cfa603c3","946":"af5b68bf"}[chunkId] + ".chunk.js";
};